import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'rwidget-remove-expired-ticket-modal',
    templateUrl: 'remove-expired-ticket-modal.component.html'
})
export class RemoveExpiredTicketModalComponent {
    constructor(public dialogRef: MatDialogRef<RemoveExpiredTicketModalComponent>) {}

    public closeDialog(): void {
        this.dialogRef.close();
    }

    public removeTicket(): void {
        this.dialogRef.close(true);
    }
}
